import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PieCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { PIE_CHART } from "../../../../Data/Charts/ApexChart";

const PieChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={PieCharts} />
        <CardBody>
          <div id="piechart">
            <Chart options={PIE_CHART} series={PIE_CHART.series} type="pie" height={300} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PieChart;
